<label class="radio-container side-{{side}} d-flex align-items-center" [class.disabled]="disabled">
  <ng-content></ng-content>
  <input type="radio" [name]="name" [value]="value" [disabled]="disabled" [checked]="isChecked"
         (change)="onRadioChange($event)">
  <span class="checkmark"></span>
</label>